<template>
  <section>
    <BackNavAndMobileHeader
      header-title="Basic Info"
    />
    <LoadingSpinner v-if="loading" header="Getting questions"/>

    <section class="pt-md-5" v-else>

      <h3 class="mb-2 mt-md-5 pt-md-2">Has anything changed since your last visit?</h3>
      <p v-if="!dnqReturnApp" class="pb-4 type-500">We have pulled information from your previous application.</p>
      <client-only>
        <form name="update-info" class="marketplace-content" :class="{'pt-4': dnqReturnApp}">
          <div class="form-section d-flex flex-wrap row">
            <div v-for="(question, index) in formQuestions" :key="question.alias" ref="form" class="form-question col-12">
              <borrower-attribute
                :question="question"
                :update-index="index"
                :invalidity="invalidity"
                @invalidity="updateValidity(question.alias, $event)"
                @answer="updateQuestion">
              </borrower-attribute>
            </div>
          </div>
        </form>
        <XButton
            class="btn-primary mt-2"
            :disabled="isInvalid || !!transitioning || savingAnswers || !!navigating"
            :submitting="savingAnswers || !!transitioning || advancing"
            @clicked="saveQuestions"
            v-show="!loadingQuestions || advancing">
          Next
        </XButton>
      </client-only>
    </section>
    <ChatBot/>
  </section>
</template>

<script>
import ChatBot from '~/components/ChatBot'
import BorrowerAttribute from '~/components/borrowerAttributes/BorrowerAttribute.vue'
import LoadingSpinner from "~/components/marketplace/subComponents/LoadingSpinner"
import XButton from "~/components/Form/Button"
import BackNavAndMobileHeader from '~/components/marketplace/subComponents/BackNavAndMobileHeader.vue'
import pageFormMixin from '~/components/Form/page-form-mixin'
import { useProgressStore } from '~/store/progress'
import { mapState } from 'pinia'
import { useQuestionsStore } from '~/store/questions'

export default {
  name: 'Basic-info',
  layout: 'marketplace',
  components: {
    ChatBot,
    LoadingSpinner,
    BorrowerAttribute,
    XButton,
    BackNavAndMobileHeader
  },
  mixins: [pageFormMixin],
  props: {
      data: {
        type: Array,
        required: true
      }
    },
  data () {
    return {
      formFieldList: [
        ...this.data
      ],
    }
  },
  computed: {
    ...mapState(useQuestionsStore, ['loadingQuestions']),
    ...mapState(useProgressStore,  ['sortedApplications', 'dnqReturnApp', 'hasAdvanced']),
    freshForm() {
      const marketplaceApp = this.sortedApplications.find(app => app.type == 'dnqReturn' || app.type == 'marketplace')
      return marketplaceApp && marketplaceApp.type == 'dnqReturn' && !this.hasAdvanced('/updated-info', this.appName || 'marketplace')
    },
    loading() {
      return this.loadingQuestions && !this.savingAnswers && !this.advancing && !this.transitioning
    },
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .form-section {
    max-width: 365px;
  }
</style>
